import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from 'config';
import { PolicyRequest, PolicyResponse } from 'types/policy';

import { defaultHeadersCommercialInsurance } from './defaultHeaders';
import { createCustomBaseQuery } from './utils/customBaseQuery';

const customBaseQuery = createCustomBaseQuery({
  baseUrl: config.msCommercialInsApi,
  defaultHeaders: defaultHeadersCommercialInsurance,
  reducerPath: 'premiumsApi',
});

/* Define a service using a base URL and expected endpoints */
export const premiumsApi = createApi({
  reducerPath: 'premiumsApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    quotePremiums: builder.mutation<PolicyResponse, PolicyRequest>({
      query: (body) => ({
        url: '/premiums',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useQuotePremiumsMutation } = premiumsApi;
